import error from './error.en'
import links from './links.en'
import words from './words.en'
import header from './header.en'
import validations from './validations.en'

export default {
  error,
  links,
  words,
  header,
  validations,
} as const
